import React from "react";
import { withFocusable, Tag } from "../../services/visualLibraryService";
import { withAppState } from "../../state";
import Logo from "../../components/Logo";
import { i18n } from "../../services/i18nService";
import {
  BuyAssetPageStyled,
  HeadingSection,
  BodySection,
  BorderDiv,
  FooterSections,
  FooterTextStyled,
  HeadingBorder,
  BuyAssetContainer,
  LogoStyled,
  HeadingContentStyled,
  HeadingStyle,
  StepContainer,
  StepNumber,
  StepText,
  PriceStyled,
  DetailsContainerStyle,
  TextStyled,
  QRCodeWrapper,
  ButtonModelWrapper,
  ButtonModalStyled,
  TextContainer
} from "./styles/Styled";
import { Loading } from "../../services/visualLibraryService";
import { getOneTimeAuthToken, getWebPortalURL, getTVODAssetsStatus } from "../../services/tvodService";
import { base64Encode, generateSignatureSHA512 } from "../../utils/encodingUtil";
import { config } from "../../config/config";
import QRCodeReact from "react-qr-code";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getLocaleFromLocalCache } from "../../services/localeCacheService";
import { getSdk } from "../../services/sdkService";
import { trackPage } from "../../services/analyticsService";
import { getCurrentProfile } from "../../services/multipleProfilesService";

const INIT = "INIT";
const PAGE = "buyAsset";

const ButtonModalFocus = withFocusable(ButtonModalStyled);
const cancelFocusPath = "buttonCancelBuyAsset";
const refreshFocusPath = "buttonRefreshBuyAsset";

class BuyAsset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: (this.props.location && this.props.location.state && this.props.location.state.data) || {},
      loading: false,
      sectionLoaded: false,
      QRCodeURL: ""
    };
    this.pollingFinishTime = new Date(Date.now() + 5 * 60 * 1000); // the next five minutes
    this.refreshQRCode = this.refreshQRCode.bind(this);
  }

  async getQRCode() {
    const { contentTitle, contentId, contentOldPrice, contentNewPriceId, contentType } = this.state.data;
    const token = await getOneTimeAuthToken();
    const locale = getLocaleFromLocalCache();
    trackPage.call(this, PAGE);

    const signature = {
      assetId: contentId,
      subscriptionType: contentType,
      priceProduct: contentNewPriceId
    };
    const hashedSignature = generateSignatureSHA512(signature);
    let urlQueryParams = `assetTitle=${contentTitle}&assetId=${contentId}&subscriptionType=${contentType}&priceProduct=${contentNewPriceId}&token=${token}&signature=${hashedSignature}`;
    urlQueryParams = contentOldPrice ? `${urlQueryParams}&oldPrice=${contentOldPrice}` : urlQueryParams;
    const profile = await getCurrentProfile();
    const profileName = profile?.profileName;
    const profileId = profile?.profileId;
    urlQueryParams = `${urlQueryParams}&profileId=${profileId}&profileName=${profileName}`;
    const encodedURLPart = base64Encode(urlQueryParams);

    return `${getWebPortalURL()}/${locale}/settings/tvpayment/tvodpayment/checkout?key=${encodedURLPart}`;
  }

  async pollingTime() {
    const { contentId } = this.state.data;
    const pollingIntervalTime = config.get().buyAssetOrBrand && config.get().buyAssetOrBrand.pollingTime;
    this.timer = setInterval(async () => {
      try {
        const currentDateTime = new Date(Date.now());
        if (currentDateTime > this.pollingFinishTime) {
          clearInterval(this.timer);
          await this.backUserWithUpdatedData();
        } else {
          let result = await getTVODAssetsStatus(contentId);
          if (result && result.length > 0 && result[0].status === INIT) {
            clearInterval(this.timer);
            await this.backUserWithUpdatedData();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }, pollingIntervalTime);
  }

  async componentDidMount() {
    this.props.onRef && this.props.onRef(this);
    this.setState({ loading: true, sectionLoaded: true });

    let qrCodeURL = await this.getQRCode();

    this.setState({
      QRCodeURL: qrCodeURL,
      loading: false,
      sectionLoaded: false
    });

    await this.pollingTime();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  async onBack() {
    this.backUserWithUpdatedData();
    return true;
  }

  async refreshQRCode() {
    clearInterval(this.timer);
    this.setState({ sectionLoaded: true });
    let qrCodeURL = await this.getQRCode();

    this.setState({
      QRCodeURL: qrCodeURL,
      loading: false,
      sectionLoaded: false
    });

    await this.pollingTime();
  }

  async backUserWithUpdatedData() {
    const { history } = this.props;
    const sdk = await getSdk();
    await sdk.mediaManager.clearLayoutCache();
    history.goBack();
  }

  render() {
    const { contentTitle, contentPrice, contentCurrency, contentImage, contentType, contentTypeShow } = this.state.data;
    const { loading } = this.state;
    const rentDisclaimerHours = config.get().rentDisclaimerTime.days;
    const rentDisclaimerMins = config.get().rentDisclaimerTime.hours;
    let assetPrice = `${contentCurrency ? contentCurrency : ""} ${contentPrice}`;
    return loading ? (
      <Loading overlay />
    ) : (
      <>
        <BuyAssetPageStyled background={contentImage}>
          <LogoStyled>
            <Logo />
          </LogoStyled>
          <BuyAssetContainer>
            <HeadingSection>
              <Tag backColor="default" text={contentTypeShow?.toUpperCase()} color="black" size="medium" />
              <HeadingStyle>
                <HeadingContentStyled rank={1} text={contentTitle} size="large" />
                <PriceStyled rank={1} text={assetPrice} size="large" />
              </HeadingStyle>
              <TextContainer>
                <TextStyled
                  rank="3"
                  text={
                    contentType === "rent"
                      ? i18n.get("pages.detail.disclaimer.rent", rentDisclaimerHours, rentDisclaimerMins)
                      : i18n.get("pages.detail.disclaimer.purchase")
                  }
                  size="small"
                />
              </TextContainer>
            </HeadingSection>
            <HeadingBorder />
            <BodySection>
              <DetailsContainerStyle>
                <>
                  <StepContainer>
                    <StepNumber>1</StepNumber>
                    <StepText rank="3" text={i18n.get("pages.buyasset.step1")} size="medium" />
                    <BorderDiv />
                  </StepContainer>
                  <StepContainer>
                    <StepNumber>2</StepNumber>
                    <StepText rank="3" text={i18n.get("pages.buyasset.step2")} size="medium" />
                    <BorderDiv />
                  </StepContainer>
                  <StepContainer>
                    <StepNumber>3</StepNumber>
                    <StepText rank="3" text={i18n.get("pages.buyasset.step3")} size="medium" />
                  </StepContainer>
                </>
              </DetailsContainerStyle>
              {!this.state.sectionLoaded ? (
                <QRCodeWrapper>
                  <QRCodeReact value={this.state.QRCodeURL} size={403} />
                </QRCodeWrapper>
              ) : (
                <Loading overlay opacity="0" />
              )}
            </BodySection>
            <HeadingBorder />
            <FooterSections>
              <FooterTextStyled rank="3" text={i18n.get("pages.buyasset.qrRefresh")} size="small" />
              <ButtonModelWrapper>
                <ButtonModalFocus
                  label={i18n.get("pages.buyasset.refresh").toUpperCase()}
                  focusPath={refreshFocusPath}
                  onEnterPress={() => this.refreshQRCode()}
                  onMouseUp={() => this.refreshQRCode()}
                  onClick={() => this.refreshQRCode()}
                  size="medium"
                />
              </ButtonModelWrapper>
            </FooterSections>
            <HeadingBorder />
            <FooterSections>
              <FooterTextStyled rank="3" text={i18n.get("pages.buyasset.cancelPage")} size="small" />
              <ButtonModelWrapper>
                <ButtonModalFocus
                  label={i18n.get("pages.buyasset.done").toUpperCase()}
                  focusPath={cancelFocusPath}
                  onEnterPress={() => this.backUserWithUpdatedData()}
                  onMouseUp={() => this.backUserWithUpdatedData()}
                  onClick={() => this.backUserWithUpdatedData()}
                  size="medium"
                />
              </ButtonModelWrapper>
            </FooterSections>
          </BuyAssetContainer>
        </BuyAssetPageStyled>
      </>
    );
  }
}

const Component = withAppState(withSubtheme(BuyAsset));
Component.defaultFocusPath = cancelFocusPath;
export default Component;
